//WE.Flow.Html.Contracts.Manifests.Components.ExternalComponentManifest
import { ToolbarItemManifest } from "./ToolbarItemManifest";
import { GroupMenuManifest } from "./GroupMenuManifest";

export class ExternalComponentManifest {
    isExternalComponent: boolean = false;
    id: string = "";
    toolbarItem: ToolbarItemManifest = null;
    defaultParameters: any = null;
    name: string = "";
    absoluteUrl: string = "";
    relativeUrl: string = "";
    moduleRoles: string[] = null;
    groupMenuItem: GroupMenuManifest = null;
    isFlow3Component: boolean = false;
    productId: string = "";
    payload: any = null;
    isFlow3Context: boolean = false;
    includeCacheBusterAsQueryParam: boolean = false;
    tags: string[] = null;
}
